var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"breadcrumb"},_vm._l((_vm.items),function(i){return _c('li',{key:i.route,staticClass:"breadcrumb-item",class:{ active: i.active }},[_c('router-link',{attrs:{"to":{ name: i.route }}},[_vm._v(_vm._s(i.label))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }